import { render, staticRenderFns } from "./PersonalTable.vue?vue&type=template&id=35217a19"
import script from "./PersonalTable.vue?vue&type=script&lang=js"
export * from "./PersonalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports